import React from 'react';
import {
  Select,
  TreeSelect,
  TreeSelectProps,
  SelectProps,
  Flex,
  Row,
  Checkbox,
  Pagination,
  Col,
  Button,
} from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import {
  FilterCommonInnerProps,
  FilterCommonProps,
  FilterTypes,
} from '@/component/FilterCommon/Filter';
import { orderHost } from '@/component/Filter/services/common/orderHost';
import { OrderHostModel } from '@/component/Filter/Model/common/ordeHost'
import { SelectModalPc } from '../Common/SelectModalPc';
import {
  DhbFilterForm,
  DhbFooterProps,
} from '@/component/PageComponent/PageComponent';
import { useGetData } from '@/component/PageComponent/hooks/requst';
import { TableResize } from '@/component/PageComponent/Table/TableResize';
import { useSelectRow } from '@/component/PageComponent/Table/hooks/columns';
import { useSelectModalList } from '../hooks/useSelectModalList';
import { LabeledValue } from 'antd/es/select';
import { useRequest } from 'ahooks' 
type FilterParams = Partial<{
  page: number;
  pageSize: number;
  kw?: string;
}>;

const initParams: FilterParams = {
  page: 1,
  pageSize: 10,
};
const columns = [
  {
    width: 80,
    title: '序号',
    dataIndex: 'sequence',
    render: (text:string, record:any, index:number) => {
      return index + 1;
    },
  },
  {
    width: 500,
    title: '门店名称',
    dataIndex: 'companyName',
  },
  {
    width: 300,
    title: '联系人',
    dataIndex: 'contact',
  },
  {

    title: '手机号',
    dataIndex: 'mobile',
  }
];
const DhbFooter = (
  props: DhbFooterProps & { onCancel(): void; onOk(): void },
) => {
  const {
    selectedRowKeys = [],
    onChange,
    dataSource = [],
    isAllSelect,
    total = 0,
    pageInfo,
    toggleSelectRowKeys,
  } = props;
  const { page = 1, pageSize = 10 } = pageInfo;

  return (
    <div style={{ padding: '10px' }}>
      <Row>
        <Col span={14}>
          {/* <Checkbox
          style={{ marginLeft: '23px' }}
          checked={isAllSelect}
          // indeterminate={isAllSelect}
          onChange={toggleSelectRowKeys}
        /> */}
          <Pagination
            style={{ textAlign: 'left' }}
            defaultPageSize={pageSize}
            total={total}
            current={page}
            onChange={(page, pageSize) => onChange({ page: page, pageSize })}
            onShowSizeChange={(current, pageSize) =>
              onChange({ page: 1, pageSize })
            }
            showQuickJumper={false}
          />
        </Col>
        <Col span={10}>
          <div style={{ textAlign: 'right' }}>
            <Button
              onClick={() => props.onCancel()}
              style={{ margin: '0 10px' }}
            >
              取消
            </Button>
            <Button type="primary" onClick={() => props.onOk()}>
              确定
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

type CompanyItem = OrderHostModel.GetCompanyListResponse['companies'][number]
const listKey = 'companyID';
interface StaffListModalProps {
  onChangeValues(values:string[],options: LabeledValue[],dataSource:CompanyItem[]):void;
  onClose(): void;  
  value: any;
}
const StaffListModal = (props: StaffListModalProps) => {
  const [staffs, setStaffs] = React.useState<CompanyItem[]>([]);
  const [count, setCount] = React.useState(0);
  const allCompaniesRef = React.useRef<CompanyItem[]>([]);
  const fetchAllCompanies = async () => {
    let page = 1;
    const pageSize = 1000;
    let total = 0;
    let all: CompanyItem[] = [];
    while (true) {
      const res = await orderHost.getCompanyList({ companyIDs: [], page, pageSize });
      debugger
      const data = res.data;
      const list = data.companies || [];
      total = data.total || list.length;
      all = all.concat(list);
      if (all.length >= total || list.length < pageSize) {
        break;
      }
      page += 1;
    }
    allCompaniesRef.current = all;
    console.log(all,"all")
    // 初始渲染第一页
    setCount(all.length);
    return all;
  };
  const getStaffs = async (params: FilterParams) => {
    const { page = 1, pageSize = 10, kw } = params;
    // 前端模糊查询与分页
    let source = allCompaniesRef.current;
    if (!source.length) {
      source = await fetchAllCompanies();
    }
    const filtered = kw
      ? source.filter((item) =>
          (item.companyName || '').toLowerCase().includes((kw || '').toLowerCase()),
        )
      : source;
    setCount(filtered.length);
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    
    setStaffs(filtered.slice(start, end));
  };
  let { setParams, setPageInfo, loading, pageInfo, params } = useGetData({
    getData: getStaffs,
    defaultParams: initParams,
  });
  const {  selectedRowKeys,  isAllSelect,  toggleSelectRowKeys,setSelectedRowKeys,} = useSelectRow(staffs, listKey);
  React.useEffect(() => {
    // 初始化时拉取全部数据并渲染首页
    (async () => {
      await fetchAllCompanies();
      getStaffs({ ...params, ...pageInfo });
    })();
  }, []);
  return (
    <Flex vertical style={{ height: '100%',padding:0}}>
      <h2 style={{ paddingLeft: '16px',margin:'16px 0 0 0' }}>选择门店</h2>
      <DhbFilterForm
        defaultParams={initParams}
        loading={loading}
        onSearch={(params) => setParams(params)}
        filterProps={{
          filters: [
            {
              type: FilterTypes.Input,
              dataIndex: 'kw',
              flex: 3,
              placeholder: '门店名称',
            },
          ],
        }}
      />
      <TableResize
        style={{ flex: 1, padding: '0 20px 16px 16px' }}
        rowKey={listKey}
        pagination={false}
        columns={columns}
        dataSource={staffs}
        rowSelection={{
          selectedRowKeys: selectedRowKeys,
          onChange: (keys) => {
            setSelectedRowKeys(keys as any);
          },
        }}
        size="middle"
      />
      <DhbFooter
        selectedRowKeys={selectedRowKeys}
        dataSource={staffs}
        isAllSelect={isAllSelect}
        toggleSelectRowKeys={toggleSelectRowKeys}
        onChange={(pageInfo) => {
          setPageInfo(pageInfo);
        }}
        total={count}
        pageInfo={pageInfo}
        onCancel={() => {
          props.onClose();
        }}
        onOk={() => {
          props.onClose();
          let selectedRow: CompanyItem[] = [];
          staffs.forEach((item) => {
            if (selectedRowKeys.includes(item[listKey].toString())) {
              selectedRow.push(item);
            }
          });
          let options= selectedRow.map(item => ({label:item.companyName,value:item.companyID.toString()}))
          props.onChangeValues &&
            props.onChangeValues(selectedRowKeys, options, selectedRow);
        }}
      />
    </Flex>
  );
};

export interface FilterStoreNamePcProps extends SelectProps{


}

export const FilterStoreNamePc = (props: FilterStoreNamePcProps) => {
  const { list:staffs, setList:setStaffs,prependList } = useSelectModalList<CompanyItem>({listKey:'companyID',value:props.value,componentKey:'filterCompanyPc'})
  const [isFirstFoucus,setIsFirstFoucus] = React.useState<boolean>(true);
  const {  ...reset } = props;
  const allCompaniesRef = React.useRef<CompanyItem[]>([]);
  const {run:getStaffs,loading} = useRequest(async (params?:{kw?:string}) => {
    const kw = params?.kw || '';
    // 首次拉取全部公司，pageSize=1000，前端分页与模糊搜索
    if (!allCompaniesRef.current.length) {
      let page = 1;
      const pageSize = 1000;
      let total = 0;
      let all: CompanyItem[] = [];
      // while (true) {
        const res = await orderHost.getCompanyList({ companyIDs: [], page, pageSize });
        const data = res.data;
        const list = data.companies || [];
        total = data.total || list.length;
        all = all.concat(list);
        if (all.length >= total || list.length < pageSize) {
          // break;
        }
        page += 1;
      // }
      allCompaniesRef.current = all;
    }
    const source = allCompaniesRef.current;
    const filtered = kw ? source.filter(item => (item.companyName || '').toLowerCase().includes(kw.toLowerCase())) : source;
    // 下拉默认只渲染20条
    setStaffs(filtered.slice(0,20));
  },{manual:true});
  // React.useEffect(() => {
  //   getStaffs();
  // }, []);
  let onChange: Required<SelectProps>['onChange'] = (value, option) => {
    props.onChange && props.onChange(value, option)
  };
  const focus = ()=>{
    if(isFirstFoucus){
      if(!staffs.length){
        getStaffs()
      }
      setIsFirstFoucus(false)
    }
  }
  return (
    <div>
      <SelectModalPc
        style={{ width: '100%'}}
        mode="multiple"
        onFocus={focus}
        loading={loading}
        // getInitData={focus}
        MoreComponent={({ onClose }) => (
          <StaffListModal
            value={props.value}
            onClose={onClose}
            onChangeValues={(values,option,sources)=>{
              prependList(sources)
              onChange(values,option)
            }}
          />
        )}
        placeholder={'门店名称'}
        onSearch={(kw)=>{
          getStaffs({kw})
        }}
        {...reset}
        onChange={(value, option) => {
            

          onChange && onChange(value, option);
        }}
        options={staffs.map(item=>({ label: item.companyName, value: item.companyID }))}
      />
    </div>
  );
};
